//#region libraries
import React, { useEffect, useMemo } from 'react';

import { useHistory } from 'react-router-dom';

// custom components
import { Card, CustomSpinner } from "_atoms";
import { TableHeader, TableValue } from "_molecules";
import { ClickableTable } from '_organisms';

// bootstrap
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectUserDb } from '_redux/slices/main-screen/user';
import { selectRewards, selectRewardsStatus, fetchRewards, setSelectedReward, fetchProductsByRetailerId } from '_redux/slices/prm-club/rewards';

//#endregion

const MarketplaceList = (props) => {

    // nav
    const history = useHistory();

    //#region redux 
    const dispatch = useDispatch();
    const rewards = useSelector(selectRewards);
    const dbUser = useSelector(selectUserDb)
    const status = useSelector(selectRewardsStatus);
    //#endregion

    //#region use effects
    // get products on render
    useEffect(() => {
        if (dbUser) {
            if (dbUser.details.authority === "RETAILER") {
                dispatch(fetchProductsByRetailerId(dbUser._id))
            } else dispatch(fetchRewards(dbUser.details.authority));
        }
    }, []);

    //#endregion

    // navigate to product information page on click of row
    const handleClick = (productIndex) => {
        dispatch(setSelectedReward(rewards[productIndex]))
        history.push('/product-information');
    };

    const columns = useMemo(
        () => [
            {
                Header: <TableHeader title={'Product'} />,
                accessor: "productTitle",
                Cell: ({ cell: { value } }) => <TableValue title={value} />
            },
            {
                Header: <TableHeader title={'Retailer'} />,
                accessor: "retailerTitle",
                Cell: ({ cell: { value } }) => <TableValue title={value} />
            },
            /*{
              Header: <TableHeader title={'Status'} />,
              accessor: "status",
              Cell: ({cell:{value}}) => <Status />
            },*/
        ],
        []
    );

    return (
        <Row>
            {/* clickable table */}
            <Row className="mt-3 mr-3">
                {status == 'loading' ?
                    // loading spinner
                    <CustomSpinner rowCenter={true} />
                    :
                    // list of products
                    <Card>

                        <ClickableTable
                            columns={columns}
                            data={rewards && rewards.length > 0 ? rewards : []}
                            handleClick={handleClick}
                        />
                    </Card>
                }
            </Row>
        </Row>
    );
}



export default MarketplaceList;

